/**
 * References to files that are not referenced from anywhere in the project but need to be included in the webpack bundle.
 */
import '../emailResources/atkins-logo.png';
import '../emailResources/footer.png';
import '../emailResources/logo.png';
import '../emailResources/us-email-footer.png';
import '../emailResources/us-email-header.png';
import '../ezmSample/EZM_Sample_Apparatus.png';
import '../ezmSample/EZM_Sample_Boring.png';
import '../ezmSample/EZM_Sample_Building.png';
import '../ezmSample/EZM_Sample_Demolition.png';
import '../ezmSample/EZM_Sample_Explosives.png';
import '../ezmSample/EZM_Sample_HandheldPowerTools.png';
import '../ezmSample/EZM_Sample_MechanicalExcavation.png';
import '../ezmSample/EZM_Sample_Piling.png';